/**
 * @desc 详情
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.PageViewResponseDto>;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/view/info/${code}`, {
      method: "POST",

      ...options,
    }),
  );
}
